export default {
    data: () => ({
        translations: {
            title: {
                el: "Εξαργύρωση κωδικού Κουπονιού",
                en: "Redeem Voucher Code",
                it: "Riscattare codice del Buono"
            },
            info: {
                el: "Πληκτρολογήστε εδώ τον κωδικό του κουπουνιού για να επιβεβαιώσετε αν το κουπόνι είναι ενεργό και έγκυρο.",
                en: `
                    Type here the voucher code of your customer to check if the voucher is active and valid.
                `,
                it: "Digita qui il codice del buono del tuo cliente per verificare se il buono e attivo e valido."
            },
            voucherCode: {
                el: "Κωδικός Κουπονιού",
                en: "Voucher Code",
                it: "Codice del buono"
            },
            validation: {
                el: "",
                en: "Validation",
                it: ""
            },
            redeem: {
                el: "Εξαργύρωση",
                en: "Redeem",
                it: "Riscatta"
            },
            notificationTitle: {
                el: "Επιτυχής εξαργύρωση",
                en: "Successful redemption",
                it: "Redenzione riuscita"
            },
            notificationDescription: {
                el: "Ο πελάτης κέρδισε:",
                en: "The customer has won the following:",
                it: "Il cliente ha vinto:"
            },
            info2: {
                el: 'Οι κωδικοί κουπονιών παράγονται όταν οι πελάτες εξαργυρώνουν πόντους απο την εφαρμογή στο κινητό τους, είτε για το γενικό σύστημα ποντοδοσίας ή για τα κουπόνια που έχουν δημιουργηθεί από εσάς στην κατηγορία "Κουπόνια"',
                en: `
                    Voucher codes are produced when a client with mobile app redeem points either for
                    your general point system or coupons created by you from the section "coupons"
                `,
                it: "I codici dei buoni vengono prodotti quando un cliente con l' applicazione mobile riscatta i punti o per il vostro sistem generale di punti o i buoni creati da voi dalla sezione 'buoni'"
            }
        }
    })
};
